/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDownBetweenLines: {
  name: 'arrow-down-between-lines';
  data: string;
} = {
  name: 'arrow-down-between-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a1 1 0 0 0-2 0v16a1 1 0 1 0 2 0V4Zm5-1a1 1 0 0 1 1 1v13.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 17.586V4a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
